module.exports = __webpack_public_path__ + "static/img/mifi17.6bcf6914.png";